module.exports = __webpack_public_path__ + "img/蒋云.5faa0202.png";